<template lang="pug">
.total_wrap
  #wrap_sub
    .sub_left
    .sub_right
      .content_title
      .content_desc
        #s11
          .in
            .s11_a.sub
              h2.s_tit
                span Greetings
              .cont
                .ceo
                  .img
                  .txt
                    h3(data-aos='fade-down')
                      | Every beer maker emphasizes freshness. 
                      br
                      | However, the best way or maybe the only way to enjoy the freshest beer is 
                      br
                      span.yell.bold to drink beer at the place where the beer is made.
                    p(data-aos='fade-down' data-aos-delay='200')
                      span INTHEKEG’s journey started from the goal of developing a solution to allow our customers to enjoy the beer at the peak of freshness. The Smart Brewery Platform is an integrated solution that enables anyone to make fresh beer (including fermenting/aging/storing) using INTHEKEG's devices that are designed to convert the wort contained in the SMARTKEG into beer. The platform allows the users to produce and sell up to ten different types of 18-liter beer, total 180 liters at a time. 
                      span The core value that INTHEKEG delivers to customers is not just ‘easy to make and sell beer’ but ‘giving customers diverse options to choose for the freshest beer’.
                      span The INTHEKEG system helps make it less likely that the taste of beer changes over time and does not require distribution process because clients can make and sell beer on the spot where the equipment is installed. 
                      span Simply put, the INTHEKEG system itself is none other than a brewery.
                      span We hope that our Smart Brewery Platform provides our customers with the valuable opportunity to enjoy beer as fresh as one that has just been produced in a brewery.
                      span Thank you.
                    h4(data-aos='fade-down' data-aos-delay='100')  All INTHEKEG employees
                .info
                  .info1.info_list(data-aos='fade-right')
                    h3 Head Office
                    h4 827, 8F, 282, Hagui-ro, Dongan-gu, Anyang-si, Gyeonggi-do, Republic of Korea
                    ul
                      li
                        h5 TEL.
                        p +82-31-423-3642
                      li
                        h5 FAX.
                        p +82-31-426-4907
                      li.email
                        h5 E-MAIL.
                        p info@inthekeg.com
                  .info2.info_list(data-aos='fade-right' data-aos-delay='200')
                    h3 Plant
                    h4 233-115, Jayu-ro, Gunsan-si, Jeollabuk-do, 54004, Republic of Korea
                    ul
                      li
                        h5 TEL.
                        p +82-63-466-0564
                  .info3.info_list(data-aos='fade-right' data-aos-delay='400')
                    h3 R&D Center
                    h4 5F, 25, Obongsandan 3-ro, Uiwang-si, Gyeonggi-do, 16079, Republic of Korea
            .s11_b.sub
              h2.s_tit
                span History
              .cont
                .img_wrap
                  .img
                  .history
                    .year(v-for="year in history.year" :key="year")
                      .lt(data-aos="fade-right")
                        h3 {{year}}
                      .md(data-aos='fade-right' data-aos-delay='100')
                        span
                      .rg(data-aos='fade-right' data-aos-delay='200')
                        ul
                          li(v-for="(month, index) in setMonth(year)" :key="index")
                            h4 {{month}}
                            .h_con
                              p(v-for="(text, idx) in setContent(year, month)" :key="idx") {{text}}
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      history: {},
    };
  },
  computed: {
    ...mapGetters(['lan']),
  },
  methods: {
    getData() {
      this.$_axios('GET', 'board/content/history', { nation: this.lan }).then(
        res => {
          this.history = res.data.res[0];
        },
      );
    },
    setMonth(year) {
      let date = this.history.date;
      let result = [];
      date.forEach((e, i) => {
        if (e.includes(year)) {
          result.push(e.split('-')[1]);
        }
      });
      return result;
    },
    setContent(year, month) {
      let content = this.history.content;
      let result = [];
      let date = `${year}-${month}`;
      content.forEach((e, i) => {
        if (e[date]) {
          result = e[date];
        }
      });
      return result;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
br.mo {
  display: none;
}
#s11 .s11_a .cont .txt h3 {
  font-weight: 500;
}
</style>
